import { useCompanySettings } from "domain/shared/hooks/useAppSettings";
import { useCallback } from "react";
import colors from "theme/colors";

export default function useCheckIdVerification(isManager: boolean) {
  const config = useCompanySettings();

  if (!config) return (id_verification: any) => null

  const { id_verification: companyIdVerification = undefined } = config

  const check = useCallback((id_verification: any) => {
    const isVerified = !!companyIdVerification;

    if (!id_verification) return null;

    const { intelicheck = false, scandit = false, expired = false, intellicheck_workflow_response: intellicheckWorkflowResponse = '' } = id_verification || {};
    const isValid = !!(companyIdVerification === 'scandit' ? scandit : intelicheck);
    // const isValid = scandit || intelicheck;

    const flags = {
      passed: { icon: 'shield-check', color: colors.ID_VERIFICATION.GREEN },
      flag: { icon: 'shield-check', color: colors.ID_VERIFICATION.YELLOW },
      fail: { icon: 'shield-off', color: colors.ID_VERIFICATION.RED },
    }

    if (intellicheckWorkflowResponse.length) {
      return flags[intellicheckWorkflowResponse as keyof typeof flags]
    }

    if (isVerified && !isManager) {
      return { icon: 'shield-check', color: colors.WHITE };
    }

    const checked = isManager && isVerified;

    if (checked && isValid) {
      return { icon: 'shield-check', color: !expired ? colors.ID_VERIFICATION.GREEN : colors.ID_VERIFICATION.YELLOW };
    }

    if (checked && !isValid) {
      return { icon: 'shield-off', color: colors.ID_VERIFICATION.RED };
    }

    return null;
  }, [companyIdVerification, isManager]);

  return check;
}